module.exports = __webpack_public_path__ + "img/dg.37a3a2fd.png";